import { render, staticRenderFns } from "./EdDialog.vue?vue&type=template&id=5570960b&scoped=true&"
import script from "./EdDialog.vue?vue&type=script&lang=js&"
export * from "./EdDialog.vue?vue&type=script&lang=js&"
import style0 from "./EdDialog.vue?vue&type=style&index=0&id=5570960b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570960b",
  null
  
)

export default component.exports